import { useQuery } from '@mint-lib/query-client';
import { useFlags, useService } from '@mint-lib/routing-context';
import { AppsFlyerIntegrations } from '@mint-sdk/api-integrations';

const getIntegrations = async () => {
  const { data } = await AppsFlyerIntegrations.getAppsFlyerIntegrations({});
  return data;
};

export const useGetAppsFlyerIntegrations = ({
  enabled,
}: {
  enabled: boolean;
}) => {
  const ff = useFlags('@mint/arm', ['integrationsQuerySdk']);
  const isIntegrationSdkEnabled = ff.integrationsQuerySdk.enabled;
  const [queryClient] = useService({
    name: 'queryClient',
    suspense: true,
  });

  const { data, isLoading } = useQuery({
    queryKey: ['appsflyer'],
    queryFn: getIntegrations,
    enabled: enabled && !isIntegrationSdkEnabled,
  });

  const classicQuery = useQuery(
    {
      ...AppsFlyerIntegrations.getQueryOptions({}),
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled: enabled && isIntegrationSdkEnabled,
    },
    queryClient,
  );

  if (isIntegrationSdkEnabled) {
    return {
      data: classicQuery.data,
      isLoading: classicQuery.isLoading,
    };
  }

  return {
    data,
    isLoading,
  };
};
